import { ModelBase } from '../abstract/model-base.model';
import { Account } from '../accounting/account.model';
import { ProductType } from './product-type.model';
import { Tax } from '../core/tax.model';
import { TaxDetail } from '../core/taxDetail.model';

export class ProductGroup extends ModelBase {

    static override CLASS_NAME: string = 'ProductGroup';

    private _label!: string;
    private _chargeAccount!: Account;
    private _chargeTax!: Tax;
    private _productAccount!: Account;
    private _productTax!: Tax;
    private _taxExemptionDetail!: TaxDetail;
    private _productType!: ProductType;

    public set chargeAccount(value: any) {
        this._setValue('_chargeAccount', value, 'Account');
    }

    public get chargeAccount(): Account {
        return this._chargeAccount;
    }

    public set chargeTax(value: any) {
        this._setValue('_chargeTax', value, 'Tax');
    }

    public get chargeTax(): Tax {
        return this._chargeTax;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get label(): string {
        return this._label;
    }

    public set productAccount(value: any) {
        this._setValue('_productAccount', value, 'Account');
    }

    public get productAccount(): Account {
        return this._productAccount;
    }

    public set productTax(value: any) {
        this._setValue('_productTax', value, 'Tax');
    }

    public get productTax(): Tax {
        return this._productTax;
    }

    public set productType(value: any) {
        this._setValue('_productType', value, 'ProductType');
    }

    public get productType(): ProductType {
        return this._productType;
    }

    /**
     * Motif de l'exonération attachée à la **nature du bien** — #1089.
     *
     * Le pendant de `Partner.taxExemptionDetail`, pour ce qui tient à ce qu'on vend
     * plutôt qu'à qui l'achète : biens de première nécessité, carburants, opérations
     * immobilières. Il ne vaut que sur un groupe réglé sur la taxe à 0 %, et la liste
     * offerte est bornée par le serveur (`?holder=product`).
     */
    public get taxExemptionDetail(): TaxDetail {
        return this._taxExemptionDetail;
    }

    public set taxExemptionDetail(value: any) {
        this._setValue('_taxExemptionDetail', value, 'TaxDetail');
    }
}
